var UnlockableFeature;
(function (UnlockableFeature) {
    UnlockableFeature["SAT"] = "SAT";
    UnlockableFeature["DOCSIS"] = "DOCSIS";
    UnlockableFeature["DAB"] = "DAB";
})(UnlockableFeature || (UnlockableFeature = {}));
export default UnlockableFeature;
